import React from 'react'
import {useIntl} from 'react-intl'
import {Radio} from '_uiComponents'
import {HStack, StackProps, VStack, useMultiStyleConfig} from '@chakra-ui/react'
import {useDrawer} from '_context'

type SortingType = {value: string; label: string}

interface SortByTemplateProps {
    sortingOptions: SortingType[]
    defaultValue?: string
    handleOnChange: (value: string) => void
}

const SortByTemplate = ({sortingOptions, defaultValue, handleOnChange}: SortByTemplateProps) => {
    const styles = useMultiStyleConfig('SortByTemplate') as Record<string, StackProps>
    const {formatMessage} = useIntl()
    const {closeDrawer} = useDrawer()

    return (
        <HStack {...styles.radioWrapper} data-testid="sort-by-template">
            <Radio
                as={VStack}
                options={sortingOptions || []}
                defaultValue={defaultValue}
                aria-label={formatMessage({id: 'sorting.plp.name', defaultMessage: 'SORT BY:'})}
                onChange={(value) => {
                    handleOnChange(value)
                    closeDrawer()
                }}
            />
        </HStack>
    )
}

export {SortByTemplate}
